"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "/" },
  { label: "Kuttos BMS", href: "/bms" },
  { label: "Kuttos AI", href: "/ai" },
  { label: "Mobile", href: "/mobile-apps" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        borderBottom: "1px solid var(--st-line)",
        background: "rgba(10,13,18,0.78)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
    >
      <nav className="st-section" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
        <Link href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/images/kuttoslogo.png" alt="Kuttos Technologies" style={{ height: 34, width: "auto", display: "block" }} />
        </Link>

        {/* desktop links */}
        <div className="st-nav-desktop" style={{ display: "flex", gap: 22, alignItems: "center" }}>
          {LINKS.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className="st-link"
              style={{
                fontSize: 13.5,
                color: pathname === l.href ? "var(--st-cyan)" : undefined,
              }}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="st-nav-desktop" style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <Link href="/auth/signup" className="st-btn st-btn-primary" style={{ fontSize: 13, padding: "9px 16px" }}>
            Get started
          </Link>
        </div>

        {/* mobile toggle */}
        <button
          type="button"
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
          className="st-nav-mobile-toggle"
          style={{
            display: "none",
            width: 38,
            height: 38,
            borderRadius: 9,
            background: "var(--st-surface)",
            border: "1px solid var(--st-line)",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </nav>

      {/* mobile panel */}
      {open && (
        <div className="st-nav-mobile-panel" style={{ display: "none", borderTop: "1px solid var(--st-line)", background: "var(--st-bg2)", padding: "12px 24px 18px" }}>
          {LINKS.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="st-link"
              style={{ display: "block", padding: "11px 0", fontSize: 15, borderBottom: "1px solid var(--st-line)" }}
            >
              {l.label}
            </Link>
          ))}
          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <Link href="/auth/signup" onClick={() => setOpen(false)} className="st-btn st-btn-primary" style={{ flex: 1, fontSize: 14, padding: "11px 0" }}>
              Get started
            </Link>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 820px) {
          .kuttos-site .st-nav-desktop { display: none !important; }
          .kuttos-site .st-nav-mobile-toggle { display: flex !important; }
          .kuttos-site .st-nav-mobile-panel { display: block !important; }
        }
      `}</style>
    </header>
  );
}
